import {useI18n} from 'i18n/I18nContext'
import React from 'react'
import {useFormicForm} from 'TemplateEditor/Layout/Blocks'
import {DefaultBlockConfig} from 'TemplateEditor/Layout/Blocks/DefaultBlockConfig'
import {VideoConfigType} from 'TemplateEditor/Layout/Blocks/Video/Video'
import {StringInput} from 'TemplateEditor/Layout/Blocks/ConfigInputs/StringInput'
import {DefaultBlockTopConfig} from 'TemplateEditor/Layout/Blocks/DefaultBlockTopConfig'
import {SwitchInput} from 'TemplateEditor/Layout/Blocks/ConfigInputs/SwitchInput'
import {SliderInput} from 'TemplateEditor/Layout/Blocks/ConfigInputs/SliderInput'
import {TEMPLATE_EDITOR_ACTIVE_FORM_ID} from 'TemplateEditor/templateEditorFormId'

export function VideoConfig() {
  const {t} = useI18n()
  const {handleSubmit, values, setFieldValue} = useFormicForm<VideoConfigType>()

  return (
    <>
      <form id={TEMPLATE_EDITOR_ACTIVE_FORM_ID} onSubmit={handleSubmit}>
        <DefaultBlockTopConfig values={values} setFieldValue={setFieldValue} />

        <SwitchInput
          value={values.controls}
          name={'controls'}
          label={t('templateEditor.videoControlsLabel')}
          setFieldValue={setFieldValue}
        />

        <StringInput
          value={values.url}
          name={'url'}
          label={t('templateEditor.videoUrlLabel')}
          setFieldValue={setFieldValue}
          info={
            <span
              style={{
                fontSize: 12,
                lineHeight: '18px',
                display: 'inline-block',
                paddingTop: 5,
              }}
            >
              {t('templateEditor.videoUrlHint')}
            </span>
          }
        />

        <SliderInput
          value={values.width}
          name={'width'}
          label={t('templateEditor.widthLabel')}
          setFieldValue={setFieldValue}
          max={1000}
          min={0}
          step={1}
        />

        <SliderInput
          value={values.height}
          name={'height'}
          label={t('templateEditor.heightLabel')}
          setFieldValue={setFieldValue}
          max={1000}
          min={0}
          step={1}
        />

        <DefaultBlockConfig values={values} setFieldValue={setFieldValue} />
      </form>
    </>
  )
}
